import React from "react";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { openAppDownloadModal } from "../../../Utils/appDownloadConfig";
import SimpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import DownloadourMobileApp from "../../../assets/img/iphone id.svg";
import Instagram from "../../../assets/img/Instagram.svg";
import Facebook2 from "../../../assets/img/Facebook2.svg";
import Linkedin from "../../../assets/img/Linkedin.svg";
import Twitter from "../../../assets/img/Twitter.svg";
import Youtube from "../../../assets/img/Youtube.svg";
import androidIcon from "../../../assets/img/android icon.svg";
import Tiktok from "../../../assets/img/tiktok 2.svg";


const Footer = () => {
  const navigation = useNavigate();
  const { globalLoading } = useGlobalState();
  if (globalLoading) return null;

  const handleViewDetails = (path) => {
    navigation(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "instant" });
    }, 100);
  };

  return (
    <>
      <div>
        <div className="footer-line"></div>
        <div className="main">
          <div className="hero-width footer custom_container">
            <Row className="footer-width text-md-start mt-3 mt-sm-4 mt-md-5">
              {localStorage.getItem("clientData") ? (
                <Col
                  lg={3}
                  md={4}
                  sm={6}
                  col={6}
                  className="mt-2 mt-sm-4 mt-md-2 col_sm_padding"
                >
                  <h5 className="footer-text-head fw-bold">For Clients</h5>
                  <ul className="list-unstyled mt-2 mt-sm-4">
                    <li>
                      <p
                        className="footer-text mb-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleViewDetails("/client/dashboard");
                        }}
                      >
                        Get Bids
                      </p>
                    </li>
                    <li>
                      <p
                        className="footer-text mb-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleViewDetails("/client-faqs");
                        }}
                      >
                        Client FAQs
                      </p>
                    </li>
                  </ul>
                </Col>
              ) : localStorage.getItem("professionalData") ? (
                <Col
                  lg={3}
                  md={4}
                  sm={6}
                  col={6}
                  className="mt-2 mt-sm-4 mt-md-2 col_sm_padding"
                >
                  <h5 className="footer-text-head fw-bold">
                    For Professionals
                  </h5>
                  <ul className="list-unstyled  mt-2 mt-sm-4">
                    <li>
                      <p
                        className="footer-text mb-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleViewDetails("/professional/jobs");
                        }}
                      >
                        Find Jobs
                      </p>
                    </li>
                    <li>
                      <p
                        className="footer-text mb-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleViewDetails("/professional-faqs");
                        }}
                      >
                        Professional FAQs
                      </p>
                    </li>
                  </ul>
                </Col>
              ) : (
                <>
                  <Col
                    lg={3}
                    md={4}
                    sm={6}
                    col={6}
                    className="mt-2 mt-sm-4 mt-md-2 col_sm_padding"
                  >
                    <h5 className="footer-text-head fw-bold">For Clients</h5>
                    <ul className="list-unstyled mt-2 mt-sm-4">
                      <li>
                        <p
                          className="footer-text mb-0"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleViewDetails("/select-role");
                          }}
                        >
                          Get Bids
                        </p>
                      </li>
                      <li>
                        <p
                          className="footer-text mb-0"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleViewDetails("/client-faqs");
                          }}
                        >
                          Client FAQs
                        </p>
                      </li>
                    </ul>
                  </Col>

                  <Col
                    lg={3}
                    md={4}
                    sm={6}
                    col={6}
                    className="mt-2 mt-sm-4 mt-md-2 col_sm_padding"
                  >
                    <h5 className="footer-text-head fw-bold">
                      For Professionals
                    </h5>
                    <ul className="list-unstyled  mt-2 mt-sm-4">
                      <li>
                        <p
                          className="footer-text mb-0"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleViewDetails("/select-role");
                          }}
                        >
                          Find Jobs
                        </p>
                      </li>
                      <li>
                        <p
                          className="footer-text mb-0"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleViewDetails("/professional-faqs");
                          }}
                        >
                          Professional FAQs
                        </p>
                      </li>
                    </ul>
                  </Col>
                </>
              )}

              <Col
                lg={3}
                md={4}
                sm={6}
                col={6}
                className="mt-2 mt-sm-4 mt-md-2 col_sm_padding"
              >
                <h5 className="footer-text-head fw-bold">Company</h5>
                <ul className="list-unstyled mt-2 mt-sm-4">
                  <li>
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/about-us");
                      }}
                    >
                      About SimpleRenovate
                    </p>
                  </li>
                  <li>
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/how-it-works");
                      }}
                    >
                      How SimpleRenovate Works
                    </p>
                  </li>
                  <li>
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/how-we-vet-professionals");
                      }}
                    >
                      How We Vet Professionals
                    </p>
                  </li>
                  {/* <li>
                    <Link
                      className="footer-text"
                      to="/service/:serviceName"
                      onClick={() => handleViewDetails()}
                    >
                      Services
                    </Link>
                  </li> */}
                  <li>
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/blogs");
                      }}
                    >
                      Blog
                    </p>
                  </li>
                  <li>
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/contacts-us");
                      }}
                    >
                      Contact Us
                    </p>
                  </li>
                </ul>
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                col={6}
                className="mt-2 mt-sm-4 mt-md-2 col_sm_padding"
              >
                <h5 className="footer-text-head fw-bold">Follow us</h5>
                <ul className="list-unstyled social-links mt-2 mt-sm-4">
                  <li>
                    <img src={Instagram} alt="Instagram" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.instagram.com/simplerenovate"
                      target="_blank"
                    >
                      Instagram
                    </Link>
                  </li>
                  <li>
                    <img src={Facebook2} alt="Facebook2" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.facebook.com/profile.php?id=61577018560484"
                      target="_blank"
                    >
                      Facebook
                    </Link>
                  </li>
                  <li>
                    <img src={Linkedin} alt="Linkedin" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.linkedin.com/company/simplerenovate"
                      target="_blank"
                    >
                      LinkedIn
                    </Link>
                  </li>
                  <li>
                    <img src={Twitter} alt="Twitter" />
                    <Link
                      className="footer-text ms-2"
                      to="https://x.com/SimpleRenovate"
                      target="_blank"
                    >
                      X
                    </Link>
                  </li>
                  <li>
                    <img src={Youtube} alt="Youtube" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.youtube.com/@simplerenovate"
                      target="_blank"
                    >
                      YouTube
                    </Link>
                  </li>
                  <li>
                    <img src={Tiktok} alt="TikTok" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.tiktok.com/@simplerenovate?_r=1&_t=ZT-922So8Fge9V"
                      target="_blank"
                    >
                      TikTok
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>

            <Row className="footer-bottom mt-3 hero-width">
              <Col md={12} sm={12} className="col_sm_padding_footer">
                <div className="footer_img_link">
                  <div className="me-0 me-xs-3 me-sm-5">
                    <div
                      onClick={() => {
                        handleViewDetails("/");
                      }}
                    >
                      <img
                        src={SimpleRenovate}
                        alt="SimpleRenovate Logo"
                        className="footer-logo img-fluid"
                      />
                    </div>
                    <span className="d-block mt-2 ft-500 ft-15">
                      © 2026 SimpleRenovate.
                    </span>{" "}
                  </div>
                  <div className="flex_link_footer">
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/terms-of-services");
                      }}
                    >
                      Terms of Service
                    </p>
                    <p
                      className="footer-text mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleViewDetails("/privacy-policies");
                      }}
                    >
                      Privacy Policy
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  className="footer-apps ctm-download-link"
                  onClick={openAppDownloadModal}
                >
                  <p className="ft-500 ft-15">Download our Mobile App</p>
                  <img
                    src={DownloadourMobileApp}
                    alt="Download App"
                    className="img-fluid"
                  />
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
